// extracted by mini-css-extract-plugin
export default {"form":"style_form__d9UDL","input":"style_input__8rddp","button":"style_button__K3Y9p"};